var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7579 17.5001V17.5002C23.7578 18.0317 23.4936 18.5244 23.0509 18.8181L11.0942 29.1111C10.9408 29.2129 10.7338 29.171 10.632 29.0175L10.5412 28.8805C9.9312 27.9602 10.1823 26.7197 11.1022 26.1091L20.522 17.5001L11.1022 8.89101C10.1823 8.28043 9.9312 7.03993 10.5412 6.11964L10.632 5.9826C10.7338 5.82906 10.9408 5.78716 11.0942 5.88903L23.051 16.182C23.4936 16.4758 23.7579 16.9686 23.7579 17.5001Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.e464ae524f8b7c37d0c79ec7fe0a42d5.svg";
export { ForwardRef as ReactComponent };